export default {
  // Basket
  SET_BASKET_URL: 'SET_BASKET_URL',
  BASKET_REQUEST: 'BASKET_REQUEST',
  SELECT_DELIVERYADDRESS: 'SELECT_DELIVERYADDRESS',
  SELECT_PAYMENT_SERVICE: 'SELECT_PAYMENT_SERVICE',
  SELECT_DELIVERY_SERVICE: 'SELECT_DELIVERY_SERVICE',
  SET_ADRESSES: 'SET_ADRESSES',
  SET_SERVICES: 'SET_SERVICES',
  SET_REFERENCE: 'SET_REFERENCE',
  SET_COMMENT: 'SET_COMMENT',
  SET_ADDITIONALINFO: 'SET_ADDITIONALINFO',
  SAVE_BASKET_AND_CREATE_ORDER: 'SAVE_BASKET_AND_CREATE_ORDER',
  CREATE_ORDER: 'CREATE_ORDER',
  // REDIRECT_TO_PROCESS: 'REDIRECT_TO_PROCESS',

  // checkout
  SET_CUSTOMER_URL: 'SET_CUSTOMER_URL',
  GET_CUSTOMER: 'GET_CUSTOMER',

  SET_SERVICE_URL: 'SET_SERVICE_URL',
  GET_SERVICES: 'GET_SERVICES',
  BASKET_STEP_CONTINUE: 'BASKET_STEP_CONTINUE',
  ADDRESS_STEP_CONTINUE: 'ADDRESS_STEP_CONTINUE',
  SERVICE_STEP_CONTINUE: 'SERVICE_STEP_CONTINUE',
  ADDITIONALINFO_STEP_CONTINUE: 'ADDITIONALINFO_STEP_CONTINUE',
  SUMMARY_STEP_CONTINUE: 'SUMMARY_STEP_CONTINUE',
  FAST_CHECKOUT_START: 'FAST_CHECKOUT_START',
  SET_CHECKOUT_FORM_FROM_BASKET: 'SET_CHECKOUT_FORM_FROM_BASKET',
  SET_INITIAL_ADDRESSES: 'SET_INITIAL_ADDRESSES',
  SET_INITIAL_SERVICES: 'SET_INITIAL_SERVICES',

  SET_ORDER_URL: 'SET_ORDER_URL',

  SET_CHECKOUT_INFOS: 'SET_CHECKOUT_INFOS',

  // Options
  SET_OPTIONS_URL: 'SET_OPTIONS_URL',
  OPTIONS_REQUEST: 'OPTIONS_REQUEST',

  // Search
  PRODUCT_SEARCH: 'PRODUCT_SEARCH',
  TRACK_PRODUCT_SEARCH: 'TRACK_PRODUCT_SEARCH',

  // Products
  GET_PRODUCTS: 'GET_PRODUCTS',
  CLEAR_PRODUCTS: 'CLEAR_PRODUCTS',
  GET_PRODUCT: 'GET_PRODUCT',
  CLEAR_PRODUCT: 'CLEAR_PRODUCT',
  GET_PRODUCT_SPAREPARTS: 'GET_PRODUCT_SPAREPARTS',
  GET_PRODUCT_ATTRIBUTES: 'GET_PRODUCT_ATTRIBUTES',

  // Client
  GET_CLIENT: 'GET_CLIENT',

  // BLOCKINGREASONS
  GET_BLOCKINGREASONS: 'GET_BLOCKINGREASONS',
  GET_ADDRESS_FOR_SAP_ID: 'GET_ADDRESS_FOR_SAP_ID',
  HAS_BLOCKINGREASON_KEY: 'HAS_BLOCKINGREASON_KEY',

  // FAVORITE
  SET_FAVORITE_URL: 'SET_FAVORITE_URL',
  FAVORITE_REQUEST: 'FAVORITE_REQUEST',
  FAVORITE_ADD_PRODUCT: 'FAVORITE_ADD_PRODUCT',
  FAVORITE_REMOVE_PRODUCT: 'FAVORITE_REMOVE_PRODUCT',
  FAVORITE_CHANGE_FAVORITE: 'FAVORITE_CHANGE_FAVORITE',
  FAVORITEPRODUCTS_REQUEST: 'FAVORITEPRODUCTS_REQUEST',
  SKU_REQUEST: 'SKU_REQUEST',

  // COMPARE
  SET_COMPARE_URL: 'SET_COMPARE_URL',
  COMPARE_REQUEST: 'COMPARE_REQUEST',
  COMPARE_ADD_PRODUCT: 'COMPARE_ADD_PRODUCT',
  COMPARE_REMOVE_PRODUCT: 'COMPARE_REMOVE_PRODUCT',
  COMPARE_SWAP_PRODUCT: 'COMPARE_SWAP_PRODUCT',

  // AVAILABILITY_WATCH
  AVAILABILITY_WATCH_REQUEST: 'AVAILABILITY_WATCH_REQUEST',
  AVAILABILITY_WATCH_ADD_PRODUCT: 'AVAILABILITY_WATCH_ADD_PRODUCT',
  AVAILABILITY_WATCH_REMOVE_PRODUCT: 'AVAILABILITY_WATCH_REMOVE_PRODUCT',
}
